import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import { useUpdateEffect } from '../../../../hooks';
import { isContactVisibleSelector } from '../../../selectors';
import { ActorContext } from './actorProvider';

export const Declarant=({renderForm,isDMS})=>{
    const contactVisibilty=useSelector(isContactVisibleSelector)
    const dataSource=useSelector((state) => state.Actor.declarant)
    const actorDetails=useContext(ActorContext)
    useUpdateEffect(()=>{
        if(contactVisibilty && isDMS){
          actorDetails.clearContactDetails("declarant") 
        }
      },[contactVisibilty])

      return renderForm ? renderForm({
        actorType:"declarant",
          boxNumber:"14",
          disabled:false,
          actorName:"DECLARANT/Representative Name",
          displayContactInfo:isDMS && !contactVisibilty,
          dataSource:dataSource
      })
      : null
    
}